export default "__VITE_ASSET__DzK8nsEw__"